export function user(state = {}, action) {
  switch (action.type) {
    case 'USER_LOGGED_IN_SUCCESS':
      if (action.fields.user) {
        return action.fields.user
      }
      else if (action.fields.username) {
        return action.fields
      } else {
        return state
      }

    case 'USER_UPDATE_PROFILE_SUCCESS':
      return action.fields

    case 'USER_LOGOUT_SUCCESS':
      return Object.assign({}, {})

    default:
      return state
  }
}

export function userIsLoading(state = false, action) {
  switch (action.type) {
    case 'USER_IS_LOGGING_IN':
      return action.userIsLoading

    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/reducers/login.jsx